<template>
    <div class="BoxWide">
        <div class="Filter">
            <form>
                <fieldset>
                    <legend>Filtra per:</legend>
                    <div class="FormRow">
                        <!--<div class="FormBox25">
                            <label>Famiglia</label>
                            <select class="CustomSelect NoSearch" name="" id="selectFamiglia">
                            <option value="all">Tutti</option>
                            <option v-for="(sito,index) in this.$store.getters.getSiti" :key="index" :value="sito.CodiceSito">{{ sito.DescrizioneOperativa }}</option>
                            </select>
                        </div>-->
                        <div class="FormBox25">
                            <label>Sito</label>
                            <select class="CustomSelect NoSearch" name="" id="selectSiti">
                            <option value="all">Tutti</option>
                            <option v-for="(sito,index) in this.$store.getters.getSiti" :key="index" :value="sito.CodiceSito">{{ sito.DescrizioneOperativa }}</option>
                            </select>
                        </div>
                        <div class="FormBox25">
                            <label>Filtro</label>
                            <select class="CustomSelect NoSearch" name="" id="selectDescr">
                            <option value="all">Tutti</option>  
                            <!--<option v-for="(unita,index) in this.$store.getters.getUnita" :key="index" :value="unita.CodiceUnita">{{ unita.Descrizione }}</option>-->                                                 
                            </select>
                        </div>
                        <div class="FormBox25">
                            <div class="TwinButtons">
                                <div class="Button ExtraSmall">
                                    <input type="button" id="" name="" value="Filtra" @click="this.filtraEntita()" />
                                </div>
                                <div class="Button ExtraSmall">
                                    <a href="javascript:void(0)" @click="this.rimuoviFiltri">Rimuovi filtri</a>
                                </div>
                            </div>
                        </div>
                    </div>                                     
                </fieldset>
            </form>
        </div>
    </div>
</template>

<script>
import FiltroModelliEntita from "@/models/filtroModelliEntita.model.js";

export default {
    name:"FiltroEntita",
    data(){
        return {
            famigliaSelected: "",
            sitoSelected: "",
            descrSeleted: ""
        }
    },
    methods:{
        filtraEntita: function(){
            this.sitoSelected = $('#selectSiti').select2('data')[0].id;            
            let filtroData  = new FiltroModelliEntita(this.sitoSelected);
            this.$emit("FiltraEntita", filtroData);
            
        },
        rimuoviFiltri: function(){

            $('#selectSiti').val("all").trigger('change'); 
            $('#selectFamiglia').val("all").trigger('change');
            $('#selectDescr').val("all").trigger('change');           
            this.sitoSelected= "all";
            this.famigliaSelected= "all";
            this.descrSeleted= "all";  

            this.$emit("RimuoviFiltri");           
        }
    },
    mounted: function(){
        $(document).ready(function() {
            $('.CustomSelect').select2({
                theme: "classic"
            });

            $('.CustomSelect').on('select2:select', function (e) {
                var codiceSito = e.params.data.id;             
                $("#sitoSelected").val(codiceSito);
            });
        });
    }

};
</script>

<style>
input[type="date"]{-webkit-appearance:none;appearance:none;}
input[type="date"]{width:100%;}
input[type="date"]{background-color:#ffffff;border:1px solid #cccccc;box-shadow:0 0 6px 0 rgba(0,0,0,0.00) inset;border-radius:0;font-family:'Open Sans', sans-serif;font-size:13px;color:#252525;}
input[type="date"]{height:36px;padding-top:3px;padding-right:12px;padding-bottom:3px;padding-left:12px;}npm 
input[type="date"]:focus{border-color:#e10712;box-shadow:0 0 6px 0 rgba(0,0,0,0.00) inset;}
</style>